import React from 'react'
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import Container from 'react-bootstrap/Container';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import NotFound from '../../components/NotFound/NotFound';
import Link from '../../components/Link/Link';
import OrderDetails from '../../components/BookingDetail/OrderDetails/OrderDetails';
import BookingIdCard from '../../components/BookingIdCard/BookingIdCard';
import PriceSplitUp from '../../components/BookingDetail/PriceDetails/PriceSplitUp/PriceSplitUp';
import ProviderDetails from '../../components/ProviderDetails/ProviderDetails';
import PaymentMethod from '../../components/BookingDetail/PriceDetails/PaymentMethod/PaymentMethod';
import CommonModal from '../../components/Modal/CommonModal';
import AdditionalRequestForm from '../../components/AdditionalRequestForm/AdditionalRequestForm';
import ViewBookingSkeleton from '../../components/Skeleton/ViewBooking/ViewBookingSkeleton/ViewBookingSkeleton';

import { closeHeaderModal, openHeaderModal } from '../../actions/siteadmin/modalActions';

import history from '../../history';
import messages from '../../locale/messages';
import { siteUrl } from '../../config';
import SocketContext from '../../core/socketNotifications/SocketContext';

import useQueryResponse from '../../lib/hooks/useQueryResponse';
import getBookingById from './getBookingById.graphql';
import getPaymentMethod from './getPaymentMethod.graphql';
import { AngleLeftArrowIcon, PrintIcon } from '../../components/Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../components/commonStyle.css';
import s from './BookingContainer.css';


function BookingContainer({ id }) {

    const { data, loading, refetch } = useQueryResponse({
        query: getBookingById,
        variables: {
            bookingId: id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })

    const { data: userPayment, loading: userPaymentLoading } = useQueryResponse({
        query: getPaymentMethod,
        fetchPolicy: 'network-only',
        ssr: false
    })

    const intl = useIntl()
    const dispatch = useDispatch()
    const additionalRequest = useSelector(state => state?.adminModalStatus?.additionalRequest)

    let categoryName, serviceFee, total, visitFee, paymentType;
    let discount, currency, status, paymentStatus, tipsAmount;

    const handleDownloadPDF = (event) => {
        event.preventDefault();
        const downloadUrl = `${siteUrl}/download-pdf?orderId=${data?.getBookingById?.result?.orderId}&userType=1`;
        window.open(downloadUrl, '_blank');
    };

    categoryName = data?.getBookingById?.result?.categoryDetails?.name
    serviceFee = data?.getBookingById?.result?.userServiceFee;
    visitFee = data?.getBookingById?.result?.travellingPrice;
    total = data?.getBookingById?.result?.userPayableFare;
    discount = data?.getBookingById?.result?.specialServiceFare;
    currency = data?.getBookingById?.result?.currency;
    status = data?.getBookingById?.result?.status;
    paymentStatus = data?.getBookingById?.result?.paymentStatus;
    tipsAmount = data?.getBookingById?.result?.tipsAmount;
    paymentType = data?.getBookingById?.result?.paymentType;

    let initialValues = {
        paymentMethodId: String(data?.getBookingById?.result?.paymentType) || '',
    };
    const redirectTo = ['declined', 'cancelledByUser', 'cancelledByPartner', 'completed', 'expired', 'scheduled'].includes(status)
        ? history?.location?.state?.from
        : (history?.location?.state?.from ? history?.location?.state?.from : `/tracking/${id}`);
    const closeAdditionalModal = () => {
        if (data?.getBookingById?.result?.additionalFeeStatus === 'approved') {
            dispatch(closeHeaderModal('additionalRequest'));
        }
    }
    let formData = {
        noCloseIcon: true
    }
    const noDataShows = ['scheduled', 'expired'].includes(data?.getBookingById?.result?.status)
    status !== 'completed' && (data?.getBookingById?.result?.additionalFeeStatus === 'pending' && dispatch(openHeaderModal('additionalRequest', formData)))

    if (!loading && data?.getBookingById?.result == null) {
        return (
            <>
                <NotFound />
            </>
        )
    } else if (loading) {
        return <div className={'subPageContainer'}><Container><ViewBookingSkeleton /></Container></div>
    } else {
        return (
            <>
                <CommonModal dialogClassName="loginSignUpModalContainer" modalHeader={"loginSignUpModalHeader"} modalBody={"loginSignUpModalBody"}
                    title={intl.formatMessage(messages.additionalWorkRequest)}
                    modalStatus={additionalRequest}
                    onHide={closeAdditionalModal}
                >
                    <AdditionalRequestForm
                        id={id}
                        fee={data?.getBookingById?.result?.requestedAdditionalFee}
                        details={data?.getBookingById?.result?.requestedAdditionalFeeDescription}
                        currency={data?.getBookingById?.result?.currency}
                        bookingDetails={data?.getBookingById?.result}
                        secondDifference={data?.getBookingById?.result?.secondDifference}
                        additionalWorkInterval={data?.getBookingById?.result?.additionalWorkInterval}
                        data={data?.getBookingById?.result} />
                </CommonModal>
                <div className={'subPageContainer'}>
                    <Container>
                        <>
                            <div className={cx(bt.space3, s.bookingTopLinkGrp)}>
                                <a href={redirectTo}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        history.back();
                                    }} className={cx(bt.customLink, 'customLinkRtl')}>
                                    <AngleLeftArrowIcon />
                                    <FormattedMessage {...messages.goBackText} />
                                </a>
                                {status === 'completed' && <Link to={''} onClick={(event) => handleDownloadPDF(event)} className={bt.customLink}>
                                    <PrintIcon />
                                    <FormattedMessage {...messages.printBooking} />
                                </Link>}
                            </div>
                            <SocketContext.Consumer>
                                {
                                    socket => (
                                        <div className={bt.commonViewBookingContainer}>
                                            <div className={bt.commonViewBookingLsBox}>
                                                <OrderDetails loading={loading} data={data?.getBookingById} isBooking socket={socket} id={id} refetch={refetch} />
                                            </div>
                                            <div className={bt.commonStickyRsContainer}>
                                                <BookingIdCard id={id} isTrackPage status={data?.getBookingById?.result?.status} isTopRadius={true} />
                                                {(data?.getBookingById?.result?.bookingType === 1 || (data?.getBookingById?.result?.bookingType === 2 && !noDataShows)) && <ProviderDetails data={data?.getBookingById?.result} isNotMapPage={true} socket={socket} />}
                                                <PriceSplitUp
                                                    data={data?.getBookingById}
                                                    categoryName={categoryName}
                                                    serviceFee={serviceFee}
                                                    visitFee={visitFee}
                                                    total={total}
                                                    discount={discount}
                                                    currency={currency}
                                                    tipsAmount={tipsAmount}
                                                    isPaymentCompleted={paymentStatus === 'completed'}
                                                    fee={data?.getBookingById?.result?.additionalFee}
                                                />
                                                {paymentStatus === 'completed' && <PaymentMethod initialValues={initialValues} isPaymentCompleted={true} userPaymentMethod={userPayment} />}
                                            </div>
                                        </div>
                                    )
                                }
                            </SocketContext.Consumer>
                        </>
                    </Container>
                </div>
            </>
        )
    }

}

export default withStyles(bt, s)(BookingContainer);
